<template>
  <div class="app-container">
    <el-row class="headTop" v-if="showShop">
      分店：<el-select class="w150 mr20" v-model="params.shopNum" clearable  placeholder="请选择分店">
          <el-option
          v-for="item in this.shopList"
          :key="item.shopNum"
          :label="item.name"
          :value="item.shopNum"
          ></el-option>
        </el-select>
      <el-button style="width:100px"   type="primary" icon="el-icon-search"  @click="queryList()">查询</el-button>
    </el-row>
    <el-dialog title="场地管理"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="130px">
          <el-form-item label="开始时间" prop="workStartTime">
            <el-time-select
              placeholder="起始时间"
              v-model="formparams.workStartTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00'
              }">
            </el-time-select>
          </el-form-item>
          <el-form-item label="场地数量" prop="num">
            <el-input class="w220" v-model.number="formparams.num" placeholder="请输入场地数量"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="单次最大预约数量">
                <el-input class="w220" v-model.number="formparams.size" placeholder="请输入单次最大预约数量"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单日最大预约数量">
                <el-input class="w220" v-model.number="formparams.maxSize" placeholder="请输入单日最大预约数量"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="是否只能连续选择">
            <el-switch
              v-model="formparams.isContinuous"
              active-value= '1'
              inactive-value= '0'
              active-text="是"
              inactive-text="否">
            </el-switch>
          </el-form-item>
            <el-form-item label="最低连选数量" v-if="formparams.isContinuous==1" prop="continuousSize">
              <el-input class="w220" v-model.number="formparams.continuousSize" placeholder="请输入最低连选数量"></el-input>
            </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="场地时长" prop="businessHours">
                <el-input  class="w220" v-model.number="formparams.businessHours" placeholder="请输入场地时长"></el-input>（单位：小时）
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="单场时长类型" prop="showUnit">
            <el-input  class="w220" v-model.number="formparams.showUnit" placeholder="请输入单场时长类型"></el-input>
          </el-form-item>
          <p style="padding-left:100px">*提示*：单场时长，1表示60分钟2表示30分钟，3表示120分钟，其他的代表输入时长</p>
          <!-- <el-form-item label="是否限制预约时间">
            <el-switch
            @change="changeStatus(status)"
              v-model="status"
              active-value= '1'
              inactive-value= '2'
              active-text="是"
              inactive-text="否">
            </el-switch>
          </el-form-item> -->
          <!-- <el-row v-if="status==1">
            <el-col :span="12">
              <el-form-item label="预约开始时间" prop="openTime">
                <el-time-picker
                  v-model="formparams.openTime"
                  value-format="HH:mm:ss"
                  placeholder="预约开始时间">
                </el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预约结束时间" prop="closeTime">
                <el-time-picker
                  v-model="formparams.closeTime"
                  value-format="HH:mm:ss"
                  placeholder="预约结束时间">
                </el-time-picker>
              </el-form-item>
            </el-col>
          </el-row>  -->
          <el-form-item label="上/下线" v-if="addType==2">
            <el-switch
              v-model="formparams.isWeb"
              active-value= '1'
              inactive-value= '0'
              active-text="上线"
              inactive-text="下线">
            </el-switch>
          </el-form-item>
          <el-form-item label="场地图片" required ref="uploadElement" prop="">
            <el-upload
              :class="{uploaderNone:hideUpload}"
              action="aa"
              ref="upload"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="uploadFile"
              :file-list="fileList"
              multiple
              :limit="1"
              :on-change="onChange"
              :on-remove="handleRemove"
              accept="image/png,image/gif,image/jpg,image/jpeg"
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            *提示*：为了更好的用户体验，图片请提供230*230像素，文件大小不超过500kb。
          </el-form-item>
         
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="78vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column label="分店">
          <template slot-scope="scope">
            <div> {{scope.row.shopNum|caseType}} </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="场地名称"></el-table-column>
         <el-table-column label="场地图片" width="100">
          <template slot-scope="scope">
            <img class="imgList" style="width:70px;height:70px" :src="'http://zlesp.zlydgy.cn:8091/images/'+scope.row.fieldimg" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="num" label="子场地数量"></el-table-column>
        <el-table-column prop="workStartTime" label="开始时间"></el-table-column>
        <el-table-column prop="businessHours" label="开场时长"></el-table-column>
        <el-table-column  label="上线/下线">
          <template slot-scope="scope">
            <div v-if="scope.row.isWeb==1"> 上线 </div>
            <div v-else> 下线 </div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="场地价格"></el-table-column>
        <el-table-column label="单场时长">
          <template slot-scope="scope">
            <div v-if="scope.row.showUnit == 1">60分钟</div>
            <div v-else-if="scope.row.showUnit == 2">30分钟</div>
            <div v-else-if="scope.row.showUnit == 3">120分钟</div>
            <div v-else>{{scope.row.showUnit}}分钟</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="限定预约时间">
           <template slot-scope="scope">
            <div>{{scope.row.openTime}}-{{scope.row.closeTime}}</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="size" label="单次最大预约数量"></el-table-column>
        <el-table-column prop="maxsize" label="单日最大预约数量"></el-table-column>
        <el-table-column label="操作" width="350">
          <template slot-scope="scope">
            <el-button type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button type="primary" @click="gositeListInfo(scope.row)">场地详情</el-button>
            <el-button type="warning" @click="getYuyueList(scope.row)">预约设置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {getOnlinePlace,insertInfSt, placegetInfI, getTbCourse, getTbTuancaorec, getShops, updateTuancaorec } from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      showShop:false,
      hideUpload: false,
      date:[],//开始时间结束时间
      rules:{
        name:[
          { required: true, message: '请选择新增场地', trigger: 'change' }
        ],
        workStartTime:[
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        continuousSize: [
          { required: true, message: '输入不能为空'}
        ],
        num:[
          { required: true, message: '输入不能为空'},
          { type: 'number', message: '输入的必须为数字值'}
        ],
        businessHours:[
          { required: true, message: '输入时长不能为空'},
          { type: 'number', message: '输入时长的必须为数字值'}
        ],
        showUnit:[
          { required: true, message: '输入单场时长不能为空'},
          { type: 'number', message: '输入单场时长的必须为数字值'}
        ],
      },
      startTime:'',
      endTime:'',
      timeList:[],
      addType:1,
      //status==1限定时间段预约 status==2 可提前时间段预约
      status:2,
      formparams:{
        name:'',
        num:'',//数量
        businessHours:'',//开场时长
        workStartTime:'',//开始时间
        showUnit:'',//单场时间 1表示60分钟 2：30 3:120 ....
        // openTime:'',
        // closeTime:'',
        shopNum:'',
        size:'',
        maxSize:'',
        shortName:'',
        isWeb:'',
        isContinuous: 0,
        continuousSize: '2'
      },
      formData:{},
      fileList:[],//图片回显示
      tableData:[],
      optionsJL:[],//私教列表
      classProject:[],//团课项目
      roomList:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        shopNum:null,
        // pageNo: 1,
        // pageSize: 20
      },
      continuousType:[
        {label:'否',value:0},
        {label:'是',value:1}
      ]
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  computed: {
      continuousSize () { return this.formparams.continuousSize }
   },
  watch: {
    continuousSize(newValue, oldValue) {
　　　if(newValue < 2 && newValue != '') {
        this.formparams.continuousSize = 2
      }
　　}
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
    if(sessionStorage.getItem('shopList')){
      this.shopList = JSON.parse(sessionStorage.getItem('shopList'))
      for (let i = 0; i < this.shopList.length; i++) {
        this.titleList.push({value:this.shopList[i].shopNum,text:this.shopList[i].name})
      }
      if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
        this.params.shopNum = this.shopList[0].shopNum
        this.showShop = false
      }else{
        this.showShop = true
      }
    } else{
      this.getShopsList()
    }
    this.placegetInfI()
  },
  mounted() {
    if(this.$route.query.queryNum){
      this.params.shopNum = this.$route.query.queryNum 
    }
    this.getTableList()
  },
  methods: {
    // changeStatus(status){
    //   // alert(status)
    //   if(status==2){
    //     this.formparams.openTime = ''
    //     this.formparams.closeTime = ''
    //   }
    // },
    getYuyueList(row){
       this.$router.push({path:'/siteModule/siteYuyue',query:{shortName:row.shortname,type:1,shopNum:row.shopNum,queryNum:this.params.shopNum}})
    },
    filterHandler(value, row, column) {
      // console.log(row)
      return row.shopNum === value;
    },
    //查询项目
    placegetInfI(){
      placegetInfI().then((res)=>{
        // console.log(res)
        this.classProject = res.data
      })
    },
    getClassProjectInfo(item){
      for (let i = 0; i < this.classProject.length; i++) {
        if(item == this.classProject[i].id){
          console.log(this.classProject[i])
          this.formparams.shopNum = this.classProject[i].shopNum
          this.formparams.name = this.classProject[i].name
          this.formparams.shortName = this.classProject[i].shortname
        }

      }
      console.log(item)
      // 根据项目查整条信息
    },
    queryList(){
      this.getTableList()
    },
    //查询场地
    getTableList(){
      getOnlinePlace(this.params).then((res)=>{
        console.log(res)
        if(res.msg == "success"){
            this.tableData = res.data
        }
        this.loading = false
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        for (let i = 0; i < this.shopList.length; i++) {
          this.titleList.push({value:this.shopList[i].shopNum,text:this.shopList[i].name})
        }
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.params.shopNum = this.shopList[0].shopNum
          this.showShop = false
        }else{
          this.showShop = true
        }
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
      })
    },
    showDialog(){
      this.dialogVisible =true
      this.addType = 1
      this.formparams.name=''
      this.formparams.shopNum=''
      this.formparams.shortName = ''
      this.formparams.size=''
      this.formparams.maxSize = ''
      this.formparams.num=''//数量
      this.formparams.businessHours=''//开场时长
      this.formparams.workStartTime=''//开始时间
      this.formparams.showUnit=''//单场时间 1表示60分钟 2：30 3:120 ...
      this.fileList=[]
    },
    gositeListInfo(row){
      this.$router.push({path:'/siteModule/siteListInfoList',query:{id:row.id,typeshortname:row.shortname,type:row.name,shopNum:row.shopNum}})
    },
    //编辑
    edit(row){
      this.addType = 2
      console.log(row)
      this.dialogVisible = true
      this.formparams.id = row.id
      this.formparams.businessHours = row.businessHours
      this.formparams.num = row.num
      this.formparams.size = row.size
      this.formparams.maxSize = row.maxsize
      this.formparams.name = row.name
      this.formparams.shortName = row.shortname
      if(row.isContinuous) {
        this.formparams.isContinuous = row.isContinuous
      }else {
        this.formparams.isContinuous = 0
      }
      if(row.continuousSize) {
        this.formparams.continuousSize = row.continuousSize
      }

      this.status = row.status
      // if(row.status==1){
      //   this.formparams.openTime = row.openTime
      //   this.formparams.closeTime = row.closeTime
      // }else{
      //   this.formparams.openTime = ''
      //   this.formparams.closeTime = ''
      // }
      if(row.state == '上线'){
        this.formparams.isWeb = '1'
      } else {
        this.formparams.isWeb = '0'
      }
     
      this.formparams.shopNum = row.shopNum
      this.formparams.workStartTime= row.workStartTime
      this.formparams.showUnit= row.showUnit
      if(this.fileList){
        this.hideUpload = true
      } else{
        this.hideUpload = false
      }
      this.fileList=[]
      this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+row.fieldimg})
    },
    handleRemove(fileList) {
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    onChange(file, fileList){
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    uploadFile(file){
      this.formData.append('uploadFile', file.file);
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if(this.$refs.upload.uploadFiles.length==0){
          this.$message.error('场地图片不能为空');
          return
        } else {
          if(this.$refs.upload.uploadFiles[0].size/1024>500){
              this.$message.error('上传图片大小不能超过500kb');
              this.fileList= []
              this.hideUpload= false
              return
          }
          if(this.$refs.upload.uploadFiles[0].name){
            let nameARR = this.$refs.upload.uploadFiles[0].name.split('.')
            var re;
            re =  /^[A-Za-z0-9]+$/g;
            if (!re.test(nameARR[0])) {
              this.$message.error('上传图片名称只能是数字字母组合');
              this.fileList= []
              this.hideUpload= false
              return
            }
          }
        }
        if (valid) {
          this.formData = new FormData()
          this.$refs.upload.submit();
          this.formData.append('id', this.formparams.id);
          this.formData.append('name', this.formparams.name);
          this.formData.append('num', this.formparams.num);
          this.formData.append('businessHours', this.formparams.businessHours);
          this.formData.append('workStartTime', this.formparams.workStartTime);
          this.formData.append('showUnit', this.formparams.showUnit);
          this.formData.append('size', this.formparams.size);
          this.formData.append('maxSize', this.formparams.maxSize);
          this.formData.append('shopNum', this.formparams.shopNum);
          this.formData.append('isWeb', this.formparams.isWeb);
          this.formData.append('shortName', this.formparams.shortName);
          this.formData.append('isContinuous', this.formparams.isContinuous);
          this.formData.append('continuousSize', this.formparams.continuousSize);
          // if(this.status==1){
          //   this.formData.append('openTime', this.formparams.openTime);
          //   this.formData.append('closeTime', this.formparams.closeTime);
          // }
          
          let config = {
              headers: {
                'Content-Type':'multipart/form-data',
                'token':sessionStorage.getItem('token')
              }
          }
          this.$http.post('place/updateInfSt', this.formData, config).then((res)=>{
            // console.log(res)
            if(res.data.msg == 'success'){
              this.dialogVisible = false
              this.$message({
                type:'success',
                message:'修改成功'
              })
              this.getTableList()
            }else{
              console.log(res)
              this.$message.error(res.data.data)
            }
          })
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getTableList()
    },
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// siteList.vue?4f797828